export default __webpack_public_path__ + "static/media/paper-texture-800-night.f40c901e.jpg";